import { hsmBackendClient } from './client';
import { ChannelProvider, IControllerResponse } from './types';

export interface PostHsmLineInput {
  /** Required for Gupshup; absent => Meta mode (data read from Kori). */
  phone?: string;
}

export interface HsmLineResult {
  websiteId: string;
  provider: ChannelProvider;
  appId?: string;
  appName?: string;
  phone?: string;
  wabaId?: string;
}

/**
 * Provisions the HSM line for a channel (website). Hits
 * `POST /website/{websiteId}/hsm/line` with `{ phone }` (Gupshup) or
 * `{}` (Meta). Returns the created line. Errors propagate so the caller can
 * map status codes (422 = app not resolved, 409 = line already exists).
 */
export async function postHsmLine(
  websiteId: string,
  input: PostHsmLineInput
): Promise<HsmLineResult> {
  const response = await hsmBackendClient.post<
    IControllerResponse<HsmLineResult>
  >(`/website/${encodeURIComponent(websiteId)}/hsm/line`, input);

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
